import React from "react";
import { motion } from "framer-motion";
import { FaBullseye } from "react-icons/fa";
import { FiCheckCircle, FiHeadphones, FiShield } from "react-icons/fi";
import AccordionExpandIcon from "./AccordionExpandIcon";
import style from "./Services.module.css";
import { useLanguage } from "../i18n";

const services = [
  {
    icon: FaBullseye,
    title: "Application-focused guidance",
    text: "We understand your workflow and recommend equipment that fits your application, performance needs, and budget.",
  },
  {
    icon: FiCheckCircle,
    title: "Reliable product sourcing",
    text: "We connect laboratories with dependable analytical, life-science, microscopy, and sample-preparation solutions.",
  },
  {
    icon: FiHeadphones,
    title: "Support beyond delivery",
    text: "Our technical team helps coordinate installation, product guidance, and responsive after-sales support.",
  },
  {
    icon: FiShield,
    title: "Trusted long-term partner",
    text: "We keep communication clear, documentation practical, and every recommendation aligned with your lab goals.",
  },
];

const Services = () => {
  const { t } = useLanguage();
  const localizedServices = services.map((service, index) => ({ ...service, title: t.services[index][0], text: t.services[index][1] }));
  return (
  <section id="why-us" className={style.contact}>
    <div className="work-section-top services-section-wrapper">
      <h2 className="primary-subheading" data-outline={t.whyUs}>
        {t.whyUs}
      </h2>
      <h3 className="section-title">{t.whyTitle}</h3>
      <p className="section-intro">
        {t.whyIntro}
      </p>
    </div>
    <div className={style.container}>
      {localizedServices.map((service, index) => (
        <motion.article
          className={style.card}
          key={service.title}
          initial={{ y: 30, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          viewport={{ once: true }}
          transition={{ delay: index * 0.08 }}
        >
          <div className={style.icon}>
            <service.icon aria-hidden="true" />
          </div>
          <div className={style.desc}>
            <h4>{service.title}</h4>
            <p>{service.text}</p>
          </div>
        </motion.article>
      ))}
    </div>
    <AccordionExpandIcon />
  </section>
  );
};

export default Services;
